import { isEmpty } from 'lodash';
import { useSnapshot } from 'valtio';
import { EditorMode, ProjectGeometryType } from '~/common/types';
import { homeMapStore as store } from '~/pages/homeViewV2/store';
import MultiButton from '../ProjectDataPanel/MultiButton';

export default function SegmentButtons() {
  const { objectsAsArray, geometryType, currentObject, inUploadKMZMode } = useSnapshot(store);
  if (
    objectsAsArray.length === 0 ||
    geometryType === ProjectGeometryType.Small_3ac ||
    geometryType === ProjectGeometryType.Circle ||
    inUploadKMZMode
  ) {
    return null;
  }

  return (
    <div className="group relative top-4 mx-2 space-y-1">
      <MultiButton
        label="Add Segment"
        isDisabled={objectsAsArray.length === 25}
        icon="plus"
        color="bg-white"
        onClick={() => {
          store.resetCurrentObjectId();
          if (objectsAsArray[0].type === 'line') {
            store.setGeometryType(ProjectGeometryType.Linear);
            store.setEditorMode(EditorMode.DrawLine);
          } else if (objectsAsArray[0].type === 'polygon') {
            store.setEditorMode(EditorMode.DrawPolygon);
            store.setGeometryType(ProjectGeometryType.Polygon);
          }
        }}
      />

      {!isEmpty(currentObject) && objectsAsArray.length > 1 && (
        <MultiButton
          label="Delete Segment"
          variant="danger"
          icon="delete"
          onClick={() => {
            store.deleteObject(store.currentObject);
            store.resetCurrentObjectId();
            if (store.objectsAsArray.length === 0) {
              store.setNewProjectMode(false);
              store.setEditorMode(EditorMode.None);
            }
          }}
        />
      )}
      {store.editorMode.startsWith('Draw') && (
        <MultiButton
          label="Discard"
          color="bg-yellow-300"
          isDisabled={objectsAsArray.length === 5}
          icon="close"
          onClick={() => {
            store.setEditorMode(EditorMode.None);
          }}
        />
      )}
    </div>
  );
}
